import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import Home from "../views/Home.vue";
import Foundation from "../views/Foundation.vue";
import Playground from "../views/Playground.vue";
import Unplugged from "../views/Unplugged.vue";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Complete from "../views/Complete.vue";

import FoundationChallenges from "../views/FoundationChallenges.vue";
import VideoCourse from "../views/FoundationVideo.vue";

import { auth } from "@/services/firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile
  },
  {
    path: "/playground",
    name: "playground",
    component: Playground
  },
  {
    path: "/unplugged",
    name: "unplugged",
    component: Unplugged
  },
  {
    path: "/complete",
    name: "complete",
    component: Complete
  },
  {
    path: "/foundation",
    redirect: "/foundation/1"
  },
  {
    path: "/foundation/:id",
    name: "foundation",
    component: Foundation
  },
  {
    path: "/video-course",
    name: "video-course",
    component: VideoCourse
  },
  {
    path: "/foundation-challenges",
    redirect: "/foundation-challenges/1"
  },
  {
    path: "/foundation-challenges/:id",
    name: "foundation-challenges-level",
    component: FoundationChallenges
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

const authenticatedPaths = [
  "/dashboard",
  "/foundation-challenges",
  "/video-course"
];

router.beforeEach((to, from, next) => {
  auth.onAuthStateChanged(async user => {
    if (user) {
      if (store.state.user.uid === "") {
        user.id = user.uid;
        await store.dispatch("user/updateUser", user).then(() => {
          to.path === "/login" ? next("/dashboard") : next();
        });
      } else {
        to.path === "/login" ? next("/dashboard") : next();
      }
    } else {
      authenticatedPaths.includes(to.path) ||
      to.path.includes("/foundation-challenges")
        ? next("/login")
        : next();
    }
  });
});

export default router;
